<template>
    <div>
        <pagamento 
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
        >
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </pagamento>
        <b-card no-body>
            <b-card-header>
                <span class="h5">DESPESAS DISPONIVEIS</span>
            </b-card-header>
            <b-card-body>
                <despesas
                    :despesas="despesasDisponiveis"
                    :incluirSelecao="true"
                >
                    <template slot="botoes">
                        <slot name="despesasBotoes"></slot>
                        <b-button-group class="float-right">
                            <b-button
                                variant="primary"
                                @click="confirmaAssociarSelecionadas()"
                                :disabled="despesasDisponiveisSelecionadas.length === 0"
                                ><i class="fa fa-plus"></i> Associar
                                selecionadas
                            </b-button>
                        </b-button-group>
                    </template>
                    <template slot="despesaAcoes" slot-scope="data">
                        <slot name="despesaAcoes" v-bind="data"></slot>
                    </template>
                    <template slot="despesaSelecao" slot-scope="data">
                        <b-form-checkbox
                            :value="data.despesaId"
                            v-model="despesasDisponiveisSelecionadas"
                        ></b-form-checkbox>
                    </template>
                </despesas>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PagamentosServicos from '../../fornecedores/pagamentos/PagamentosServicos';
import Pagamento from './PagamentoDetalhar'
import Despesas from './../despesas/Despesas2'

export default {
    props: {
        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        pagamento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            despesasDisponiveisSelecionadas: [],
            despesasDisponiveis: []
        }
    },

    methods: {
        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterDespesasDisponiveis() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterDespesasDisponiveis(this.$route.params.pagamentoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.despesasDisponiveis = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmaAssociarSelecionadas() {
            this.$swal({
                title: 'Associação de Despesas',
                html: `Confirma a associação das despesas selecionadas?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associar()
                }
            })
        },

        associar() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .associarDespesas({
                    pagamentoId: this.$route.params.pagamentoId,
                    despesasId: this.despesasDisponiveisSelecionadas
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.despesasDisponiveisSelecionadas = []
                            this.obterDespesasDisponiveis()
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },
    },

    created() {
        this.obterDespesasDisponiveis()
    },

    components: {
        Pagamento,
        Despesas
    }
}
</script>
